module.exports = "/_next/static/images/UDJ3-c76398cb4abc582d573c78e78a299584.svg";